import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  height: 40px;
  border-radius: 12px;
  border: 1px solid var(--border-soft);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px;
  gap: 4px;
`;

export const HorizonItem = styled.div`
  padding: 6px 8px;
  ${typographyV2.bodySm};

  &:hover {
    background-color: var(--surface-hover);
    cursor: pointer;
  }

  &[data-selected='true'] {
    cursor: default;
    border-radius: 8px;
    background: var(--action-primary-soft-hover);
    color: var(--text-primary);
  }
`;
